var _path, _path2, _path3, _circle, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgController(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 41.3 41.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9,17.2c.2,0,.5,0,.7,0,.9,0,1.7.3,2.3.8,1.2-1.4,1.6-3.3,1-5.1-.7-2.1-2.6-3.4-4.6-3.5-1,0-1.8.9-1.4,1.9l2.1,6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1,20.1c-1.8-.3-3.7.2-4.9,1.7-1.4,1.6-1.6,3.9-.7,5.8.5.9,1.7,1.1,2.4.3l4.1-4.8c-.2-.2-.3-.4-.4-.6-.4-.7-.6-1.6-.4-2.4Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7,22.5c-.4.7-1.1,1.3-1.9,1.6.6,1.7,2,3.1,3.9,3.4,2.1.4,4.2-.6,5.3-2.3.6-.9,0-2-.9-2.2l-6.2-1.2c0,.2-.2.5-.3.7Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.6,
    cy: 20.7,
    r: 3.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6,34.2c1.2-.2,2.3-.5,3.4-.9,1.6-.7,3.1-1.7,4.3-2.9s2.2-2.7,2.9-4.3c.7-1.7,1.1-3.5,1.1-5.3s-.4-3.6-1.1-5.3c-.7-1.6-1.7-3.1-2.9-4.3-1.3-1.3-2.7-2.2-4.3-2.9-1.7-.7-3.5-1.1-5.3-1.1s-3.6.4-5.3,1.1c-1.6.7-3.1,1.7-4.3,2.9-1.3,1.3-2.2,2.7-2.9,4.3-.7,1.7-1.1,3.5-1.1,5.3s.4,3.6,1.1,5.3c.7,1.6,1.7,3.1,2.9,4.3,1.3,1.3,2.7,2.2,4.3,2.9,1.1.5,2.2.8,3.4.9M8.7,20.7c0-6.6,5.4-12,12-12s12,5.4,12,12-5.4,12-12,12-12-5.4-12-12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgController);
export default __webpack_public_path__ + "static/media/controller.b67782035820955613371af3ff6251fe.svg";
export { ForwardRef as ReactComponent };